import { ACTION_TYPES } from "../../../Constants";
import _ from "lodash";

const isTokenValid = () => {
  const expiration = localStorage.getItem("tokenExpiration");
  return expiration && Date.now() < parseInt(expiration, 10);
};

const initialState = {
  isAuthenticated: isTokenValid(),
  token: localStorage.getItem("token") || null,
  menuToggle: false,
  userid:localStorage.getItem("userid") || "",
  userType: localStorage.getItem("userType") || "",
  subCmpny: localStorage.getItem("subcompany") || "",
  demoaccount_id: localStorage.getItem("demoaccount_id") || ""
};

const AuthReducer = (state = initialState, action) => {
 // console.log('localStorage.getItem("tokenExpiration")-->',localStorage.getItem("tokenExpiration"));
 // console.log('action-->',action)
  switch (action.type) {
    case ACTION_TYPES.AUTH: {
      if (!_.isEmpty(action?.payload?.token)) {
        localStorage.setItem("isAuthenticated", true);
        localStorage.setItem("token", action.payload?.token);
        localStorage.setItem("tokenExpiration", Date.now() + 1 * 24 * 60 * 60 * 1000);
        localStorage.setItem("userid", action.payload?._id)
        localStorage.setItem("userType", action.payload?.userType)
        localStorage.setItem("demoaccount_id", action.payload?.demoaccount_id)
        if (action.payload?.sub_companyName) {
          localStorage.setItem("subcompany", action.payload.sub_companyName);
        } else {
          localStorage.removeItem("subcompany"); 
        }
      }
      const isTokenValid = Date.now() < parseInt(localStorage.getItem("tokenExpiration"), 10);
     // console.log("isTokenValid-->",isTokenValid);
      return {
        ...state,
        isAuthenticated: !_.isEmpty(action?.payload?.token) && isTokenValid ? true : false,
        token: action.payload?.token,
        userid: localStorage.getItem("userid") || "",
        userType: localStorage.getItem("userType") || "",
        subCmpny: localStorage.getItem("subcompany") || "",
        demoaccount_id: localStorage.getItem("demoaccount_id") || ""
      };
    }
    case ACTION_TYPES.MENU_TOGGLE: {
      return {
        ...state,
        menuToggle: action.payload,
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
